module.exports = __webpack_public_path__ + "imgs/proteus.ac1e717e9b90d4837c4566b50b227ca4.jpg";